// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2mT_G","rowsWrapper":"style_rowsWrapper__215Ss","rowWrapper":"style_rowWrapper__1CnId","text":"style_text__2Ptyt"};